import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Axios from "axios";
import { useImmerReducer } from 'use-immer';
import {
    Grid, Snackbar, Typography, Button, TextField, MenuItem,
    Alert, Container, Paper, Box, CircularProgress
} from "@mui/material";
import { useTranslation } from 'react-i18next';
import StateContext from "../../../Contexts/StateContext";

import {
    areaOptions, AranyosszekOptions, CsikszekOptions, GyergyoszekOptions, KaszonfiuszekOptions, KereszturfiuszekOptions,
    KezdiszekOptions, MarosszekOptions, MiklosvarfiuszekOptions, OrbaiszekOptions, SepsiszekOptions, UdvarhelyszekOptions,
} from "../../../Constants/GeographicConstants";

function AddSummerSportItem() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const GlobalState = useContext(StateContext);

    const config = require('../../../config').default;
    const environment = require('../../../config').environment;

    const initialState = {
        titleValue: '',
        descriptionValue: '',
        areaValue: '',
        boroughValue: '',
        priceValue: '',
        uploadedPictures: [],
        addressValue: '',
        geocodingError: '',
        geocodingSuccess: false,
        sendRequest: 0,
        openSnack: false,
        disabledBtn: false,
        error: '',
    };

    function ourReducer(draft, action) {
        switch (action.type) {
            case 'catchTitleChange': draft.titleValue = action.value; break;
            case 'catchDescriptionChange': draft.descriptionValue = action.value; break;
            case 'catchAddressChange':
                draft.addressValue = action.value;
                draft.geocodingError = '';
                draft.geocodingSuccess = false;
                break;
            case 'setGeocodingError':
                draft.geocodingError = action.value;
                draft.geocodingSuccess = false;
                break;
            case 'setGeocodingSuccess':
                draft.geocodingSuccess = true;
                draft.geocodingError = '';
                break;
            case 'catchAreaChange': draft.areaValue = action.value; break;
            case 'catchBoroughChange': draft.boroughValue = action.value; break;
            case 'catchPriceChange': draft.priceValue = action.value; break;
            case 'catchUploadedPictures': draft.uploadedPictures = action.value; break;
            case 'changeSendRequest': draft.sendRequest++; break;
            case 'openTheSnack': draft.openSnack = true; break;
            case 'disableTheBtn': draft.disabledBtn = true; break;
            case 'enableTheBtn': draft.disabledBtn = false; break;
            case 'setError': draft.error = action.value; break;
            default: break;
        }
    }

    const [state, dispatch] = useImmerReducer(ourReducer, initialState);

    const getBoroughOptions = () => {
        switch (state.areaValue) {
            case 'Aranyosszék': return AranyosszekOptions;
            case 'Csíkszék': return CsikszekOptions;
            case 'Gyergyószék': return GyergyoszekOptions;
            case 'Kászonszék': return KaszonfiuszekOptions;
            case 'Keresztúrszék': return KereszturfiuszekOptions;
            case 'Kézdiszék': return KezdiszekOptions;
            case 'Marosszék': return MarosszekOptions;
            case 'Miklósvárszék': return MiklosvarfiuszekOptions;
            case 'Orbaiszék': return OrbaiszekOptions;
            case 'Sepsiszék': return SepsiszekOptions;
            case 'Udvarhelyszék': return UdvarhelyszekOptions;
            default: return [];
        }
    };

    const handleGeocode = async () => {
        if (!state.addressValue) return;
        try {
            const response = await Axios.get(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(state.addressValue)}`);
            if (response.data && response.data.length > 0) {
                const { lat, lon } = response.data[0];
                dispatch({ type: 'catchLatitudeChange', value: parseFloat(lat) });
                dispatch({ type: 'catchLongitudeChange', value: parseFloat(lon) });
                dispatch({ type: 'setGeocodingSuccess' });
            } else {
                dispatch({ type: 'setGeocodingError', value: t('Thematic.GeocodingNoResult', 'Nem található koordináta a megadott címhez.') });
            }
        } catch (e) {
            console.error("Geocoding error:", e);
            dispatch({ type: 'setGeocodingError', value: t('Thematic.GeocodingError', 'Hiba történt a keresés során.') });
        }
    };

    function FormSubmit(e) {
        e.preventDefault();
        dispatch({ type: 'changeSendRequest' });
        dispatch({ type: 'disableTheBtn' });
    }

    useEffect(() => {
        if (state.sendRequest) {
            async function AddItemFunc() {
                const formData = new FormData();
                formData.append('title', state.titleValue);
                formData.append('description', state.descriptionValue);
                formData.append('address', state.addressValue);
                formData.append('area', state.areaValue);
                formData.append('borough', state.boroughValue);
                formData.append('price', state.priceValue);
                formData.append('seller', GlobalState.userId);
                formData.append('season', 'Summer');

                for (let i = 0; i < state.uploadedPictures.length; i++) {
                    formData.append(`picture${i + 1}`, state.uploadedPictures[i]);
                }

                try {
                    await Axios.post(config[environment].sportEquipmentEndpoint, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': `Bearer ${localStorage.getItem('token')}`
                        }
                    });
                    dispatch({ type: 'openTheSnack' });
                } catch (e) {
                    dispatch({ type: 'enableTheBtn' });
                    dispatch({ type: 'setError', value: t('Common.Error') });
                }
            }
            AddItemFunc();
        }
    }, [state.sendRequest]);

    useEffect(() => {
        if (state.openSnack) {
            setTimeout(() => navigate(`/${i18n.language}/nyari-sportfelszereles`), 1500);
        }
    }, [state.openSnack]);

    if (!GlobalState.userIsLogged) {
        return (
            <Container maxWidth="sm" sx={{ py: 8 }}>
                <Alert severity="warning">{t('Administration.LoginRequired')}</Alert>
                <Button variant="contained" onClick={() => navigate(`/${i18n.language}/login`)} sx={{ mt: 2 }}>{t('Administration.LoginButton')}</Button>
            </Container>
        );
    }

    return (
        <Container maxWidth="md" sx={{ py: 4, mt: '50px' }}>
            <Paper sx={{ p: 4 }}>
                <Typography variant="h4" gutterBottom sx={{ color: 'var(--sznodarkblue)', fontWeight: 'bold' }}>
                    {t('SubMenu.SummerSports')} +
                </Typography>
                <form onSubmit={FormSubmit}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField fullWidth label={t('Common.Title')} value={state.titleValue} onChange={(e) => dispatch({ type: 'catchTitleChange', value: e.target.value })} required />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField select fullWidth label={t('Map.Toolbox.szek')} value={state.areaValue} onChange={(e) => dispatch({ type: 'catchAreaChange', value: e.target.value })} required>
                                {areaOptions.map((option) => (<MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField select fullWidth label={t('Map.Toolbox.telepules')} value={state.boroughValue} onChange={(e) => dispatch({ type: 'catchBoroughChange', value: e.target.value })} required disabled={!state.areaValue}>
                                {getBoroughOptions().map((option) => (<MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField fullWidth type="number" label={t('Common.Price')} value={state.priceValue} onChange={(e) => dispatch({ type: 'catchPriceChange', value: e.target.value })} required />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField fullWidth multiline rows={4} label={t('Common.Description')} value={state.descriptionValue} onChange={(e) => dispatch({ type: 'catchDescriptionChange', value: e.target.value })} />
                        </Grid>

                        <Grid item container sx={{ mt: 2 }} spacing={2}>
                            <Grid item xs={12} sm={9}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    label={t('Common.Address')}
                                    value={state.addressValue}
                                    onChange={(e) => dispatch({ type: 'catchAddressChange', value: e.target.value })}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <Button
                                    fullWidth
                                    variant="outlined"
                                    onClick={handleGeocode}
                                    sx={{ height: '56px' }}
                                >
                                    {t('Thematic.Geocode')}
                                </Button>
                            </Grid>
                            {state.geocodingError && (
                                <Grid item xs={12}>
                                    <Alert severity="error" sx={{ mt: 1 }}>
                                        {state.geocodingError}
                                    </Alert>
                                </Grid>
                            )}
                            {state.geocodingSuccess && (
                                <Grid item xs={12}>
                                    <Alert severity="success" sx={{ mt: 1 }}>
                                        {t('Thematic.GeocodingSuccess')}
                                    </Alert>
                                </Grid>
                            )}
                        </Grid>

                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                component="label"
                                sx={{ bgcolor: 'var(--sznodarkblue)' }}
                            >
                                {t('Common.UploadPictures')}
                                <input
                                    type="file"
                                    multiple
                                    hidden
                                    onChange={(e) => dispatch({ type: 'catchUploadedPictures', value: e.target.files })}
                                />
                            </Button>
                            <Typography variant="body2" sx={{ mt: 1 }}>
                                {state.uploadedPictures.length} {t('Common.PicturesSelected')}
                            </Typography>
                        </Grid>
                    </Grid>
                    {state.error && <Alert severity="error" sx={{ mt: 2 }}>{state.error}</Alert>}
                    <Box sx={{ mt: 4, display: 'flex', gap: 2 }}>
                        <Button type="submit" variant="contained" disabled={state.disabledBtn}>{state.disabledBtn ? <CircularProgress size={24} /> : t('Common.Submit')}</Button>
                        <Button variant="outlined" onClick={() => navigate(-1)}>{t('Common.Cancel')}</Button>
                    </Box>
                </form>
            </Paper>
            <Snackbar open={state.openSnack} message={t('Common.Success')} autoHideDuration={2000} />
        </Container>
    );
}

export default AddSummerSportItem;